// import { createRouter, createWebHistory } from 'vue-router'
import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import ServiceView from "../views/ServiceView.vue";
import MarketingView from "../views/MarketingView.vue";
import CloudTechnologiesView from "../views/CloudTechnologiesView.vue";
import TrainingView from "../views/TrainingView.vue";
import SportsView from "../views/SportsView.vue";
import ConsultingView from "../views/ConsultingView.vue";
import ResearchView from "../views/ResearchView.vue";
import RoboticsIndustryView from "../views/RoboticsIndustryView.vue";
import BusinessIncubatorsView from "../views/BusinessIncubatorsView.vue";
import ProjectView from "../views/ProjectView.vue";
import PartnerView from "../views/PartnerView.vue";
import PictureView from "../views/PictureView.vue";
import ContactUsView from "../views/ContactUsView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
  },
  {
    path: "/service/",
    name: "service",
    component: ServiceView,
    /* children: [
      {
        path: "marketing",
        name: "marketing",
        component: MarketingView,
      },
      {
        path: "cloud-technologies",
        name: "cloud_technologies",
        component: CloudTechnologiesView,
      },
      {
        path: "training",
        name: "training",
        component: TrainingView,
      },
      {
        path: "sports",
        name: "sports",
        component: SportsView,
      },
      {
        path: "consulting",
        name: "consulting",
        component: ConsultingView,
      },
      {
        path: "research",
        name: "research",
        component: ResearchView,
      },
      {
        path: "robotics-industry",
        name: "robotics_industry",
        component: RoboticsIndustryView,
      },
      {
        path: "business-incubators",
        name: "business_incubators",
        component: BusinessIncubatorsView,
      },
    ], */
  },
  {
    path: "/marketing",
    name: "marketing",
    component: MarketingView,
  },
  {
    path: "/cloud-technologies",
    name: "cloud_technologies",
    component: CloudTechnologiesView,
  },
  {
    path: "/training",
    name: "training",
    component: TrainingView,
  },
  {
    path: "/sports",
    name: "sports",
    component: SportsView,
  },
  {
    path: "/consulting",
    name: "consulting",
    component: ConsultingView,
  },
  {
    path: "/research",
    name: "research",
    component: ResearchView,
  },
  {
    path: "/robotics-industry",
    name: "robotics_industry",
    component: RoboticsIndustryView,
  },
  {
    path: "/business-incubators",
    name: "business_incubators",
    component: BusinessIncubatorsView,
  },
  {
    path: "/project",
    name: "project",
    component: ProjectView,
  },
  {
    path: "/partner",
    name: "partner",
    component: PartnerView,
  },
  {
    path: "/picture",
    name: "picture",
    component: PictureView,
  },
  {
    path: "/contact_us",
    name: "contact_us",
    component: ContactUsView,
  },
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes,
});

/* router.beforeEach((to,from,next)=>{

  if (to.name != null){
    document.title = `${process.env.VUE_APP_TITLE} - ${to.name}`;
  } else{
    document.title = `${process.env.VUE_APP_TITLE}`;
  }
  
  next();

}); */

export default router;
